import { untag } from '@suntex.core/types';
import { $ModuleArea, $SkillSetLevel, ModuleArea } from '@suntex.fim/enums';

import { ModuleSlug, NodeModel } from '../../../types';

const G_BASE_ANGLE = 90;
const G_ANGLE_INCREMENT = 45;
const G_BASE_STEM_LENGTH = 160;
const G_STEM_LENGTH_VARIATION = 40;
const G_BASE_SIZE = 50;
const G_SIZE_INCREMENT = 5;

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.SkillSets);

export const ssNode = {
  tag: moduleAreaDesc.slug,
  alias: ['skillsets', 'skill-sets'],
  info: {
    title: moduleAreaDesc.label,
    summary: '24® Game',
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 1,
  },
  color: moduleAreaDesc.color,
  layout: 'levels',
  children: $SkillSetLevel.describeAll().map((ss) => ({
    tag: ss.slug,
    alias: [ss.value.toString()],
    icon: `modules/ss/${ss.slug}`,
    label: {
      aria: ss.label,
    },
    filtered: {
      label: ss.label,
      color: moduleAreaDesc.color,
    },

    color: ss.color,
    layout: 'skill-set',

    // eslint-disable-next-line no-magic-numbers
    children: ([1, 2, 3] as const).map(
      (g) =>
        ({
          moduleSlug: `ss-${untag(ss.value)}-${g}` as ModuleSlug,
          dataPath: ['ss', `${ss.value}`, `${g}`, 'star'],
          href: `/modules/ss/${ss.value}/${g}`,
          icon: `modules/ss/g${g}`,
          label: {
            aria: `Game ${g}`,
          },
          info: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            summary: ss.skills[g - 1]!.replace('\n', ' '),
          },
          filtered: {
            icon: `alts/ss${untag(ss.value)}-g${g}`,
            label: `${ss.label}\nGame ${g}`,
            color: moduleAreaDesc.color,
          },

          angle: G_BASE_ANGLE + g * G_ANGLE_INCREMENT,
          stemLength: G_BASE_STEM_LENGTH + G_STEM_LENGTH_VARIATION * (g % 2),
          size: G_BASE_SIZE + g * G_SIZE_INCREMENT,
        }) as NodeModel,
    ),
  })),
} as NodeModel;
